/* ══════════════════════════════════════════════════════════════
   Navigation Component — Top nav + Mobile bottom nav
   ══════════════════════════════════════════════════════════════ */

import { NAV_ROUTES, MOBILE_NAV_ROUTES } from '../config/routes';
import { getVariantConfig } from '../config/variant';
import { getThemePreference, setThemePreference } from '../router/guards';

export function renderNavigation(): string {
    const variant = getVariantConfig();
    const currentHash = window.location.hash.slice(1) || '/';
    const theme = getThemePreference();

    const navLinks = NAV_ROUTES.map(route => {
        const active = currentHash === route.path ? 'top-nav__link--active' : '';
        return `<button class="top-nav__link ${active}" data-path="${route.path}" onclick="window.location.hash='${route.path}'">${route.icon} <span class="hide-tablet">${route.label}</span></button>`;
    }).join('');

    const mobileLinks = MOBILE_NAV_ROUTES.map(route => {
        const active = currentHash === route.path ? 'bottom-nav__link--active' : '';
        return `<button class="bottom-nav__link ${active}" data-path="${route.path}" onclick="window.location.hash='${route.path}'"><span class="bottom-nav__link-icon">${route.icon}</span>${route.label}</button>`;
    }).join('');

    return `
    <!-- Top Navigation (Desktop) -->
    <nav class="top-nav glass-nav">
      <a class="top-nav__brand" href="#/">
        <span class="top-nav__brand-icon">🇮🇳</span>
        <span class="hide-mobile">India Market Monitor</span>
      </a>

      <div class="top-nav__links">
        ${navLinks}
      </div>

      <div class="top-nav__actions">
        <button class="glass-btn glass-btn--sm" onclick="document.dispatchEvent(new Event('imm:search'))" title="Search (⌘K)">
          🔍 <span class="hide-tablet">⌘K</span>
        </button>
        <button class="glass-btn glass-btn--sm" id="theme-toggle" onclick="window.__toggleTheme()" title="Toggle theme">
          ${theme === 'dark' ? '🌓' : '☀️'}
        </button>
        <span class="variant-tab variant-tab--active hide-mobile">
          ${variant.icon} ${variant.shortName}
        </span>
      </div>
    </nav>

    <!-- Bottom Navigation (Mobile) -->
    <nav class="bottom-nav glass-nav">
      <div class="bottom-nav__links">
        ${mobileLinks}
      </div>
    </nav>
  `;
}

/**
 * Initialize theme toggle handler
 */
export function initThemeToggle(): void {
    (window as unknown as Record<string, unknown>).__toggleTheme = () => {
        const current = getThemePreference();
        const next = current === 'dark' ? 'light' : 'dark';
        setThemePreference(next);
        const btn = document.getElementById('theme-toggle');
        if (btn) btn.textContent = next === 'dark' ? '🌓' : '☀️';
    };
}
